// Список monochrome-чёрных иконок которые на dark-теме автоматически
// получают `filter: brightness(0) invert(1)` (см. global.scss
// `[data-theme='dark'] .model-icon-dark`). Без этой инверсии чёрный SVG
// сливается с тёмным фоном и становится невидимым.
//
// Чтобы добавить иконку — проверь что она НЕ имеет своих цветов
// (только fill="black" или fill="currentColor" → дефолтный черный).
// Иконки с своими цветами (gemini gradient, sora blue, hailuo rainbow и т.д.)
// в инверсии не нуждаются — они выглядят правильно на обеих темах.
// eslint-disable-next-line react-refresh/only-export-components
export const DARK_ICONS = [
	'/icons/gpt.svg',
	'/icons/grok.svg',
	'/icons/flux.svg',
	'/icons/runway.svg',
	'/icons/suno.svg',
	'/icons/mureka.svg',
	'/icons/elevenlabs.svg',
	'/icons/luma.svg',
]

interface Props {
  icon: string
  name: string
  size?: number
  className?: string
  dark?: boolean
}

export default function ModelIcon({ icon, name, size = 44, className = '', dark }: Props) {
  const isDark = dark ?? DARK_ICONS.includes(icon)
  return (
    <img
      src={icon}
      alt={name}
      width={size}
      height={size}
      className={`model-icon-img ${isDark ? 'model-icon-dark' : ''} ${className}`}
      draggable={false}
      // Файла нет (реестр ссылается на несуществующий логотип) — значок убираем совсем: пустая
      // рамка сломанной картинки хуже, чем строка без логотипа.
      onError={(e) => { e.currentTarget.style.display = 'none' }}
    />
  )
}
